import { render, staticRenderFns } from "./PolicyInfo.vue?vue&type=template&id=5c2bc5eb&scoped=true&"
import script from "./PolicyInfo.vue?vue&type=script&lang=js&"
export * from "./PolicyInfo.vue?vue&type=script&lang=js&"
import style0 from "./PolicyInfo.vue?vue&type=style&index=0&id=5c2bc5eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bc5eb",
  null
  
)

component.options.__file = "PolicyInfo.vue"
export default component.exports